module.exports = __webpack_public_path__ + "img/culogo-h.d72f1066.png";